import Button from '@material-ui/core/Button';
import {useHistory} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import messages from '@super-template/messages';

export default function BackButton(props) {
  const history = useHistory();
  const go = () => {
    window.scrollTo({top: 0, behavior: 'smooth'});
    history.goBack();
  };

  return (
    <Button {...props} onClick={() => go()}>
      <FormattedMessage {...messages.back} />
    </Button>
  );
}
